/**
 * `/ai/copilot` — Microsoft 365 Copilot adoption.
 *
 * A page rather than a section on the AI overview, because it is not the same
 * subject: the overview measures the *Azure* AI estate through ARM and Azure
 * Monitor, while this reads Graph's org-level Copilot reports. One board mixing
 * both invited the reading that a Copilot number was an Azure number.
 *
 * The section component owns its own query, access states and copy, so this file
 * is deliberately thin — it supplies the frame and nothing else. `panel` is left
 * undefined: the frame's freshness and error chrome belong to the Azure snapshot,
 * and this page has no snapshot of its own to describe.
 */

import { AiCopilotSection } from "./copilot-section";
import { AiPageFrame } from "./page-frame";
import { AI_COPILOT_PATH } from "./params";

export function AiCopilotPage() {
  return (
    <AiPageFrame path={AI_COPILOT_PATH} ownsItsQuery>
      <AiCopilotSection />
    </AiPageFrame>
  );
}
